const prefix = "[SCHEDULER_OVERVIEW]";

export default {
    FETCH_SCHEDULER_CONFIGS_REQUEST: `${prefix} FETCH_SCHEDULER_CONFIGS_REQUEST`,
    FETCH_SCHEDULER_CONFIGS_SUCCESS: `${prefix} FETCH_SCHEDULER_CONFIGS_SUCCESS`,
    FETCH_SCHEDULER_CONFIGS_FAILED: `${prefix} FETCH_SCHEDULER_CONFIGS_FAILED`,
    DELETE_SCHEDULER_RULE_REQUEST: `${prefix} DELETE_SCHEDULER_RULE_REQUEST`,
    DELETE_SCHEDULER_RULE_SUCCESS: `${prefix} DELETE_SCHEDULER_RULE_SUCCESS`,
    DELETE_SCHEDULER_RULE_FAILED: `${prefix} DELETE_SCHEDULER_RULE_FAILED`,
    TOGGLE_EDIT: `${prefix} TOGGLE_EDIT`,
};
